module.exports = __webpack_public_path__ + "img/goods9_5.88bca4bd.jpg";